<template>
  <div class="input" :class="error ? 'error' : ''">
    <input type="text" :placeholder="placeholder" @change="$emit('change', $event.target.value )"/>
    <inline-svg class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--green)" v-if="approved" alt="indicator-check"/>
    <inline-svg class="indicator" :src="require(`@/assets/img/error.svg`)" v-if="error" alt="indicator-error"/>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
  components: {
    InlineSvg,
  },
  props: {
    approved: Boolean,
    error: Boolean,
    placeholder: String
  },
  data: () => ({
    approved: "",
  }),
}
</script>

<style lang="scss" scoped>
.input{
  display: inline-block;
  border: solid 1px var(--gray);
  border-radius: 4px;
  width:100%;
  &.error{
    border: solid 1px var(--red-error);
  }
}
  input{
    -webkit-appearance: none;
    outline: none;
    border: none;
    width: 100%;
    padding: 12px 16px;
  }
</style>